module.exports = __webpack_public_path__ + "static/media/lc_notofication_icon.cd9e3693.svg";